// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fancybox__container{z-index:9999999!important}.is-close-btn{top:5px!important;right:5px!important;color:#000!important}", ""]);
// Exports
module.exports = exports;
